import React, { useState } from "react";
import moment from "moment";
import { EuiDatePicker, EuiDatePickerRange } from "@elastic/eui";
import useDidUpdateEffect from "../../../../hooks/useDidUpdateEffect";
import * as localStorage from "../../../../lib/localStorage";

// const locale = localStorage.getItem('locale')
const dateFormat = "D/M/Y";

function DateRange({ onChange, defaultStartDate, defaultEndDate }) {
    const [startDate, setStartDate] = useState(
        defaultStartDate
            ? moment(defaultStartDate).startOf("day")
            : moment().subtract(7, "d").startOf("day")
    );
    const [endDate, setEndDate] = useState(
        defaultEndDate ? moment(defaultEndDate).endOf("day") : moment().endOf("day")
    );

    const isInvalid = startDate > endDate;

    useDidUpdateEffect(() => {
        if (!isInvalid) {
            onChange(startDate.locale("en").format(), endDate.locale("en").format());
        }
    }, [startDate, endDate]);

    const handleChangeStart = (date) => {
        setStartDate(date);
    };

    const handleChangeEnd = (date) => {
        setEndDate(date);
    };

    return (
        <EuiDatePickerRange
            style={{ maxWidth: "100%" }}
            startDateControl={
                <EuiDatePicker
                    selected={startDate}
                    onChange={handleChangeStart}
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat={dateFormat}
                    isInvalid={isInvalid}
                    placeholder="Start date"
                    aria-label="Start date"
                    timeFormat="HH:mm"
                />
            }
            endDateControl={
                <EuiDatePicker
                    selected={endDate}
                    onChange={handleChangeEnd}
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat={dateFormat}
                    isInvalid={isInvalid}
                    placeholder="End date"
                    aria-label="End date"
                    timeFormat="HH:mm"
                />
            }
        />
    );
}

export default DateRange;
